var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row row-single setting" }, [
      _vm.$root.app.platform == "android"
        ? _c(
            "div",
            {
              staticClass: "col col-100",
              class: { "validation-error": _vm.$v.data.email.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Nieuw E-mail")
              ]),
              _c("br"),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.data.email,
                    expression: "data.email"
                  }
                ],
                attrs: { type: "text" },
                domProps: { value: _vm.data.email },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "email", $event.target.value)
                    },
                    function($event) {
                      return _vm.$v.data.email.$touch()
                    }
                  ]
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c(
            "div",
            {
              staticClass: "col col-50",
              class: { "validation-error": _vm.$v.data.email.$error }
            },
            [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Nieuw E-mail")
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "col col-50" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.data.email,
                  expression: "data.email"
                }
              ],
              attrs: { type: "text" },
              domProps: { value: _vm.data.email },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.data, "email", $event.target.value)
                  },
                  function($event) {
                    return _vm.$v.data.email.$touch()
                  }
                ]
              }
            })
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
    _vm._v(" "),
    _c("div", { staticClass: "row row-button" }, [
      _c("div", { staticClass: "col col-100" }, [
        _c(
          "button",
          {
            staticClass: "button dub-button dub-button-space",
            on: { click: _vm.editEmail }
          },
          [_vm._v("Gegevens opslaan")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Email wijzigen")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ce4b674", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ce4b674","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmailEdit.vue
// module id = null
// module chunks = 